/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import ZoneSelection from 'solis/react/board/selection/zone';
import NoneSelection from 'solis/react/board/selection/none';


export const Preview     = { selection: new NoneSelection(), pannable: false, zoomable: false };
export const Selectable  = { selection: new ZoneSelection(), pannable: false, zoomable: false };
export const Focused     = { selection: new ZoneSelection(), pannable: false, zoomable: false, dimming: true, groupEmphasis: true };
export const Interactive = { selection: new ZoneSelection(), pannable: true,  zoomable: true, dimming: true };
